// extracted by mini-css-extract-plugin
module.exports = {"area":"area___15hqH","who":"who___2N6tZ"};